/* eslint-disable jsx-a11y/anchor-is-valid */
import {Field, Formik} from 'formik'
import moment from 'moment'
import {useEffect, useRef, useState} from 'react'
import {Modal, OverlayTrigger, Tooltip} from 'react-bootstrap'
import InputMask from 'react-input-mask'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import Logo from 'src/_metronic/assets/logo.svg'
import {API, UI_URL} from 'src/feature/bite/domain'
import {formatPhoneNumber} from 'src/feature/bite/helpers/phone'
import Swal from 'sweetalert2'
import * as Yup from 'yup'
import {
  useCancelPaymentMutation,
  useMemberPaymentQuery,
  usePaymentLinkCreateCustomer,
} from '../context'
import {useMemberPayment} from '../hook'

export default function MemberPaymentView() {
  const intl = useIntl()
  const {isLoading, data} = useMemberPaymentQuery()
  const {memberPayment, paymentId, genericPaymentLinkID, setGenericPaymentLinkID} =
    useMemberPayment()
  const paymentProviderUrl = process.env.REACT_APP_PAYMENT_PROVIDER
  const iframeRef = useRef<HTMLIFrameElement | null>(null)

  const [modal, setModal] = useState(false)
  const [paymentError, setPaymentError] = useState(false)
  const [paymentSuccess, setPaymentSuccess] = useState(false)
  const [termsModal, setTermsModal] = useState(false)
  const [termsModalMerchant, setTermsModalMerchant] = useState(false)
  const [isTermsAccepted, setIsTermsAccepted] = useState(false)
  const [cancellationModal, setCancellationModal] = useState(false)

  // new flow
  const [getPaymentModal, setGetPaymentModal] = useState(false)
  const [getPaymentUrl, setGetPaymentUrl] = useState('')
  // end: new flow

  const [cancelled, setCancelled] = useState(false)

  const {mutate: cancelPayment, isLoading: isCancelling} = useCancelPaymentMutation()
  const {mutateAsync: createCustomer} = usePaymentLinkCreateCustomer()

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event?.data && typeof event?.data === 'string' && event?.data?.includes('0/Error')) {
        setModal(false)
        setPaymentError(true)
        return
      }

      // start: new flow

      if (
        event?.data &&
        event?.data?.type === 'success' &&
        event?.data?.message?.includes('myfatoorah.com')
      ) {
        setModal(false)
        setGetPaymentUrl(event?.data?.message)
        setGetPaymentModal(true)
        return
      }

      // end: new flow
      //
      if (event.origin === paymentProviderUrl || event.origin === 'https://portal.myfatoorah.com') {
        if (event.origin === 'https://portal.myfatoorah.com') {
          const parsedDataNew = JSON.parse(event.data)
          const resultUrlNew = parsedDataNew?.url
          if (resultUrlNew && resultUrlNew?.includes('ValidatePaymentLink')) {
            const response = await fetch(resultUrlNew)
            const data = await response.text()
            if (data?.includes('1/Success')) {
              setModal(false)
              setGetPaymentModal(false)
              setGetPaymentUrl('')
              setPaymentSuccess(true)
            } else if (data?.includes('Error')) {
              setModal(false)
              setGetPaymentModal(false)
              setGetPaymentUrl('')
              setPaymentError(true)
            }
          }
        } else if (event.origin === paymentProviderUrl) {
          const resultUrl = event.data
          if (resultUrl?.includes('1/Success/')) {
            setModal(false)
            setPaymentSuccess(true)
          } else {
            setModal(false)
            setPaymentError(true)
          }
        } else {
          setModal(false)
          setGetPaymentModal(false)
          setGetPaymentUrl('')
          setPaymentError(true)
        }
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  const initialValues = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    mobilePhoneNumber: '',
    mobileCountryCode: '+971',
    linkType: memberPayment?.linkType || 2,
  }

  const validationSchema = Yup.object().shape({
    linkType: Yup.number().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    firstName: Yup.string().when(['linkType'], ([linkType], schema) => {
      if (linkType === 2) {
        return schema.required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      }
      return schema
    }),
    lastName: Yup.string().when(['linkType'], ([linkType], schema) => {
      if (linkType === 2) {
        return schema.required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      }
      return schema
    }),
    mobilePhoneNumber: Yup.string().when(['linkType'], ([linkType], schema) => {
      if (linkType === 2) {
        return schema.required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      }
      return schema
    }),
    emailAddress: Yup.string().when(['linkType'], ([linkType], schema) => {
      if (linkType === 2) {
        return schema
          .email(intl.formatMessage({id: 'GLOBAL.VALIDATION.EMAIL'}))
          .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100}))
          .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      }
      return schema
    }),
  })

  const onSubmit = async (values) => {
    //
    if (values.linkType === 2) {
      const {firstName, lastName, emailAddress, mobilePhoneNumber} = values

      const createCustomerData = {
        language: 'en',
        paymentLinkID: paymentId,
        firstName,
        lastName,
        emailAddress,
        mobilePhoneNumber: mobilePhoneNumber,
      }

      const customerData = await createCustomer(createCustomerData)

      if (!customerData || !customerData.responseResult.result) {
        Swal.fire({
          icon: 'error',
          title: 'An error occurred!',
          text: 'Unable to create customer',
          confirmButtonText: 'OK',
        })
        return
      }

      setGenericPaymentLinkID(customerData?.response?.genericPaymentLinkID)
    }

    setModal(true)
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(prop) => {
        return (
          <>
            <Modal centered show={paymentError} onHide={() => setPaymentError(false)}>
              <Modal.Header>
                <Modal.Title>Payment Error</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className='d-flex flex-column align-items-center'>
                  <svg
                    width='128'
                    height='128'
                    viewBox='0 0 128 128'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <g clip-path='url(#clip0_3280_3265)'>
                      <path
                        d='M64 128C51.342 128 38.9683 124.246 28.4435 117.214C17.9188 110.182 9.71575 100.186 4.87174 88.4918C0.0277302 76.7973 -1.23968 63.929 1.22977 51.5143C3.69923 39.0995 9.79463 27.6958 18.7452 18.7452C27.6958 9.79463 39.0995 3.69923 51.5143 1.22977C63.929 -1.23968 76.7973 0.0277302 88.4918 4.87174C100.186 9.71575 110.182 17.9188 117.214 28.4435C124.246 38.9683 128 51.342 128 64C128 80.9739 121.257 97.2525 109.255 109.255C97.2525 121.257 80.9739 128 64 128ZM64 9.84618C53.2894 9.84618 42.8193 13.0223 33.9138 18.9728C25.0082 24.9233 18.0672 33.3809 13.9684 43.2763C9.86962 53.1716 8.7972 64.0601 10.8867 74.5649C12.9763 85.0697 18.1339 94.719 25.7075 102.293C33.281 109.866 42.9303 115.024 53.4351 117.113C63.94 119.203 74.8285 118.13 84.7238 114.032C94.6191 109.933 103.077 102.992 109.027 94.0863C114.978 85.1807 118.154 74.7106 118.154 64C118.154 49.6375 112.448 35.8633 102.293 25.7075C92.1368 15.5517 78.3625 9.84618 64 9.84618Z'
                        fill='#EE383B'
                      />
                      <path
                        d='M83.2896 88.2108C82.6424 88.2049 82.0028 88.0714 81.4072 87.8179C80.8116 87.5645 80.2719 87.1961 79.8189 86.7339L44.1727 49.1123C43.3694 48.1677 42.9522 46.9547 43.0044 45.7158C43.0566 44.4769 43.5744 43.3033 44.4543 42.4296C45.3342 41.5559 46.5115 41.0464 47.7507 41.003C48.99 40.9596 50.2 41.3854 51.1389 42.1954L86.7604 79.817C87.4448 80.5054 87.9103 81.3807 88.0986 82.333C88.2868 83.2853 88.1894 84.2719 87.8185 85.1689C87.4476 86.066 86.8197 86.8333 86.0139 87.3746C85.2081 87.9158 84.2603 88.2067 83.2896 88.2108Z'
                        fill='#EE383B'
                      />
                      <path
                        d='M47.927 88.2273C46.9513 88.2281 45.9973 87.9389 45.1862 87.3965C44.3751 86.8541 43.7436 86.0828 43.3716 85.1807C42.9997 84.2787 42.9043 83.2864 43.0974 82.33C43.2905 81.3735 43.7635 80.496 44.4562 79.8089L81.847 42.4427C82.7708 41.519 84.0237 41 85.3301 41C86.6365 41 87.8894 41.519 88.8132 42.4427C89.7369 43.3665 90.2559 44.6194 90.2559 45.9258C90.2559 47.2322 89.7369 48.4851 88.8132 49.4089L51.3978 86.7504C50.9447 87.2127 50.405 87.5811 49.8095 87.8345C49.2139 88.0879 48.5742 88.2214 47.927 88.2273Z'
                        fill='#EE383B'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_3280_3265'>
                        <rect width='128' height='128' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>

                  <div className='d-flex flex-column align-items-center mt-10 w-50 text-center'>
                    <h2 className='fw-semibold fs-2 mt-3'>Payment Failed!</h2>
                    <p className='fs-6'>
                      Your order has not been completed. Please try again later.
                    </p>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button onClick={() => setPaymentError(false)} className='btn btn-primary'>
                  Close
                </button>
              </Modal.Footer>
            </Modal>

            <Modal
              centered
              show={paymentSuccess}
              onHide={() => {
                setPaymentSuccess(false)
                window.location.href = `${process.env.REACT_APP_DEJAVOOEXTRA}`
              }}
            >
              <Modal.Header>
                <Modal.Title>Payment Successful</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className='d-flex flex-column align-items-center'>
                  <svg
                    width='128'
                    height='128'
                    viewBox='0 0 128 128'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <g clip-path='url(#clip0_3270_3223)'>
                      <path
                        d='M64 128C51.342 128 38.9683 124.246 28.4435 117.214C17.9188 110.182 9.71575 100.186 4.87174 88.4918C0.0277302 76.7973 -1.23968 63.929 1.22977 51.5143C3.69923 39.0995 9.79463 27.6958 18.7452 18.7452C27.6958 9.79463 39.0995 3.69923 51.5143 1.22977C63.929 -1.23968 76.7973 0.0277302 88.4918 4.87174C100.186 9.71575 110.182 17.9188 117.214 28.4435C124.246 38.9683 128 51.342 128 64C128 80.9739 121.257 97.2525 109.255 109.255C97.2525 121.257 80.9739 128 64 128ZM64 9.84618C53.2894 9.84618 42.8193 13.0223 33.9138 18.9728C25.0082 24.9233 18.0672 33.3809 13.9684 43.2763C9.86962 53.1716 8.7972 64.0601 10.8867 74.5649C12.9763 85.0697 18.1339 94.719 25.7075 102.293C33.281 109.866 42.9303 115.024 53.4351 117.113C63.94 119.203 74.8285 118.13 84.7238 114.032C94.6191 109.933 103.077 102.992 109.027 94.0863C114.978 85.1807 118.154 74.7106 118.154 64C118.154 49.6375 112.448 35.8633 102.293 25.7075C92.1368 15.5517 78.3625 9.84618 64 9.84618Z'
                        fill='#00DD2C'
                      />
                      <path
                        d='M56.6153 92.5541C55.9681 92.5481 55.3284 92.4146 54.7329 92.1612C54.1373 91.9078 53.5976 91.5394 53.1446 91.0771L30.4984 68.4556C29.6951 67.511 29.2778 66.298 29.3301 65.0591C29.3823 63.8202 29.9001 62.6466 30.78 61.7729C31.6599 60.8992 32.8371 60.3897 34.0764 60.3463C35.3156 60.3029 36.5256 60.7287 37.4646 61.5387L60.0861 84.1602C60.7704 84.8486 61.236 85.724 61.4243 86.6763C61.6125 87.6285 61.5151 88.6152 61.1441 89.5122C60.7732 90.4092 60.1454 91.1766 59.3396 91.7178C58.5338 92.2591 57.586 92.55 56.6153 92.5541Z'
                        fill='#00DD2C'
                      />
                      <path
                        d='M56.6154 92.554C55.6396 92.5548 54.6856 92.2656 53.8746 91.7232C53.0635 91.1807 52.4319 90.4095 52.06 89.5074C51.6881 88.6053 51.5926 87.6131 51.7857 86.6566C51.9788 85.7002 52.4518 84.8227 53.1446 84.1356L90.5354 46.7694C91.4591 45.8456 92.712 45.3267 94.0184 45.3267C95.3248 45.3267 96.5777 45.8456 97.5015 46.7694C98.4253 47.6932 98.9443 48.9461 98.9443 50.2525C98.9443 51.5589 98.4253 52.8118 97.5015 53.7356L60.0861 91.0771C59.6331 91.5393 59.0934 91.9077 58.4978 92.1611C57.9023 92.4146 57.2626 92.5481 56.6154 92.554Z'
                        fill='#00DD2C'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_3270_3223'>
                        <rect width='128' height='128' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>

                  <div className='d-flex flex-column align-items-center mt-10 w-50 text-center'>
                    <h2 className='fw-semibold fs-2 mt-3'>Congratulations!</h2>
                    <p className='fs-6'>Your order has been successfully completed.</p>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button onClick={() => setPaymentSuccess(false)} className='btn btn-primary'>
                  Close
                </button>
              </Modal.Footer>
            </Modal>

            <Modal show={cancelled} onHide={() => setCancelled(false)}>
              <Modal.Header>
                <Modal.Title>Cancel Payment?</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  Are you sure you want to cancel this payment? You can complete the payment using
                  the same link until it expires.
                </p>
              </Modal.Body>
              <Modal.Footer>
                <button
                  onClick={() => cancelPayment()}
                  className='btn btn-danger'
                  disabled={isCancelling}
                >
                  Cancel Payment
                </button>
                <button onClick={() => setCancelled(false)} className='btn btn-success'>
                  Continue to Payment
                </button>
              </Modal.Footer>
            </Modal>
            <Modal show={termsModal} onHide={() => setTermsModal(false)} size='lg'>
              <Modal.Header closeButton>
                <Modal.Title>Terms & Conditions Agreement</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  <strong>User Agreement for Vasco Life LLC</strong>
                </p>
                <p>
                  This User Agreement ("Agreement") is a legally binding contract between Vasco Life
                  LLC ("Vasco", "we", "us", or "our"), the Merchants ("Merchant"), and the Users
                  ("User" or "you") participating in the program facilitated by Vasco’s Platform,
                  App(s), Wallet Solutions ("Wallet"), and Website(s) (collectively, the
                  "Services"). By accessing or using the Services, you agree to be bound by the
                  terms and conditions outlined below.
                </p>
                <p>
                  <strong>Definitions</strong>
                </p>
                <p>
                  <strong>a. Vasco</strong>
                </p>
                <p>
                  Vasco Life LLC is the provider of the Services, which include a digital platform,
                  applications, and tools enabling Merchants to manage their business programs and
                  facilitate interactions with Users. Vasco acts as a facilitator and is not
                  directly or indirectly responsible for the products or services offered by
                  Merchants.
                </p>
                <p>
                  <strong>b. Merchant</strong>
                </p>
                <p>
                  A Merchant refers to any individual or organization that uses Vasco’s Services to
                  manage programs such as product listings, promotions, and customer engagement.
                  Merchants are fully responsible for their offerings, compliance with applicable
                  laws and relevant sector regulations, and interactions with Users.
                </p>
                <p>
                  <strong>c. User (or Users)</strong>
                </p>
                <p>
                  A User is an individual who participates in a Merchant’s program through Vasco’s
                  Services. Users may engage with Merchants’ offerings, create membership accounts,
                  and provide information necessary for program participation in one or more
                  Merchants. Users are required to comply with this Agreement and any additional
                  terms set by Merchants, provided such terms align with this Agreement.
                </p>
                <p>
                  <strong>1. Acceptance of Terms</strong>
                </p>
                <p>By using the Services, you:</p>
                <ul>
                  <li>
                    Acknowledge that you have read, understood, and agree to be bound by this
                    Agreement, as well as Vasco’s Terms and Conditions and Privacy Policy.
                  </li>
                  <li>
                    Consent to the collection, use, and processing of your data as described in
                    Vasco’s Privacy Policy.
                  </li>
                  <li>
                    Agree to comply with all applicable laws and regulations while using the
                    Services.
                  </li>
                </ul>
                <p>If you do not agree to these terms, you must not use the Services.</p>
                <p>
                  <strong>2. Roles and Responsibilities</strong>
                </p>
                <p>
                  <strong>a. Vasco’s Role</strong>
                </p>
                <p>
                  Vasco provides the Services to enable Merchants to manage their programs,
                  including but not limited to product listings, promotions, and customer
                  engagement. Vasco does not own or control the products, services, pricing or
                  offers provided by Merchants.
                </p>
                <p>
                  <strong>b. Merchant’s Role</strong>
                </p>
                <p>
                  Merchants are solely responsible for the accuracy, legality, and quality of their
                  products and offerings, programs, pricing and interactions with Users. Merchants
                  must ensure compliance with this Agreement and applicable laws and relevant sector
                  regulations.
                </p>
                <p>
                  <strong>c. User’s Role</strong>
                </p>
                <p>Users agree to:</p>
                <ul>
                  <li>Use the Services for personal and lawful purposes only.</li>
                  <li>
                    Provide accurate and up-to-date information when creating membership accounts or
                    participating in programs.
                  </li>
                  <li>
                    Comply with any additional terms provided by the Merchant, provided such terms
                    are consistent with this Agreement.
                  </li>
                </ul>
                <p>
                  <strong>3. Consent to Program Terms</strong>
                </p>
                <p>By using the Services and engaging with a Merchant’s program, you:</p>
                <ul>
                  <li>
                    Agree to the specific terms, conditions, and requirements set forth by the
                    Merchant.
                  </li>
                  <li>
                    Acknowledge that Vasco acts as a facilitator and is not liable for any disputes,
                    claims, or damages arising from your participation in a Merchant’s program.
                  </li>
                  <li>
                    Grant Vasco the right to collect and process your data for the purpose of
                    facilitating your participation in the program, as outlined in the Privacy
                    Policy.{' '}
                  </li>
                </ul>
                <p>
                  <strong>4. User Membership Accounts and Responsibilities</strong>
                </p>
                <p>
                  To use certain features of the Services, you may need to create a membership
                  account and provide specific information:
                </p>
                <ul>
                  <li>
                    You are responsible for maintaining the confidentiality of your account
                    credentials and all activities that occur under your account.
                  </li>
                  <li>
                    You agree to notify Vasco immediately of any unauthorized access or use of your
                    account.
                  </li>
                  <li>
                    Vasco is not liable for any loss or damage arising from your failure to comply
                    with these obligations.{' '}
                  </li>
                </ul>
                <p>
                  <strong>5. Data Protection and Privacy</strong>
                </p>
                <p>
                  <strong>a. User Data</strong>
                </p>
                <p>
                  Vasco collects and processes your personal information in accordance with its
                  Privacy Policy. Merchants are responsible for ensuring compliance with applicable
                  data protection laws when collecting and using the User data.
                </p>
                <p>
                  <strong>b. Data Sharing</strong>
                </p>
                <p>
                  By participating in a Merchant’s program, you consent to the sharing of your
                  personal information between Vasco, Vasco’s designated 3<sup>rd</sup> parties and
                  the Merchant as necessary to facilitate the program.
                </p>
                <p>
                  <strong>c. User Rights</strong>
                </p>
                <p>You have the right to:</p>
                <ul>
                  <li>Access your data stored by Vasco.</li>
                  <li>
                    Request corrections or deletions of your data, subject to legal or contractual
                    restrictions.
                  </li>
                  <li>
                    Withdraw consent for data processing, which may result in limited access to
                    certain Services.
                  </li>
                </ul>
                <p>
                  <strong>6. Prohibited Activities</strong>
                </p>
                <p>You agree not to:</p>
                <ul>
                  <li>Use the Services for any unlawful, fraudulent, or malicious activities.</li>
                  <li>
                    Impersonate another person or entity or misrepresent your affiliation with any
                    person or entity.
                  </li>
                  <li>
                    Violate the intellectual property rights of Vasco, Merchants, or any third
                    party.
                  </li>
                  <li>
                    Interfere with the proper functioning of the Services, including attempting to
                    hack, disable, or disrupt the Platform, App, or Website.
                  </li>
                </ul>
                <p>
                  <strong>7. Dispute Resolution</strong>
                </p>
                <p>
                  <strong>a. User and Merchant Disputes</strong>
                </p>
                <p>
                  Any disputes between Users and Merchants regarding products, services, pricing of
                  services or program participation must be resolved directly between the parties.
                  Vasco is not liable for any such disputes.
                </p>
                <p>
                  <strong>b. Disputes Involving Vasco</strong>
                </p>
                <p>
                  Disputes between Users and Vasco, and disputes between Merchants and Vasco will be
                  resolved through arbitration or the courts of the Dubai International Financial
                  Centre (DIFC), as specified in Vasco’s Terms and Conditions.
                </p>
                <p>
                  <strong>8. Limitation of Liability</strong>
                </p>
                <p>Vasco provides the Services "as is" and is not liable for:</p>
                <ul>
                  <li>Any errors, omissions, or inaccuracies in a Merchant’s program.</li>
                  <li>Losses or damages arising from User’s reliance on a Merchant’s offerings.</li>
                  <li>
                    Indirect, incidental, or consequential damages arising from use of the Services
                    or products.
                  </li>
                </ul>
                <p>
                  <strong>9. Termination</strong>
                </p>
                <p>
                  <strong>a. User Termination</strong>
                </p>
                <p>
                  You may terminate your participation in the Services at any time by deleting your
                  membership account or providing written notice to Vasco.
                </p>
                <p>
                  <strong>b. Vasco Termination</strong>
                </p>
                <p>
                  Vasco may suspend or terminate your access to the Services for violations of this
                  Agreement, misuse of the Services, or as required by law.
                </p>
                <p>
                  <strong>c. Effect of Termination</strong>
                </p>
                <p>
                  Upon termination, your access to the Services and participation in any Merchant
                  programs will cease. Any data obtained anytime and retained by Vasco will be
                  handled in accordance with the Privacy Policy.
                </p>
                <p>
                  <strong>10. General Provisions</strong>
                </p>
                <ul>
                  <li>
                    <strong>Force Majeure</strong>: Vasco is not liable for delays or failures
                    caused by circumstances beyond its control.
                  </li>
                  <li>
                    <strong>Entire Agreement</strong>: This Agreement constitutes the entire
                    agreement between Vasco, Merchants, and Users concerning the Services.
                  </li>
                  <li>
                    <strong>Governing Law</strong>: This Agreement is governed by the laws of DIFC.
                  </li>
                  <li>
                    <strong>Severability</strong>: If any provision of this Agreement is found to be
                    unenforceable, the remaining provisions will remain in effect.
                  </li>
                </ul>
                <p>
                  If you have any questions or concerns about this Agreement, please contact Vasco
                  at <a href='mailto:help@vasco.life'>help@vasco.life</a>
                </p>
              </Modal.Body>
            </Modal>

            <Modal
              scrollable
              show={termsModalMerchant}
              onHide={() => setTermsModalMerchant(false)}
              size='lg'
            >
              <Modal.Header closeButton>
                <Modal.Title>{memberPayment?.termsAndConditionsTitle}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div
                  className='terms-content'
                  dangerouslySetInnerHTML={{__html: memberPayment?.termsAndConditions || ''}}
                ></div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  onClick={() => {
                    setTermsModalMerchant(false)
                    setIsTermsAccepted(true)
                  }}
                  className='btn btn-primary'
                >
                  Accept Terms & Conditions
                </button>
              </Modal.Footer>
            </Modal>

            <Modal show={cancellationModal} onHide={() => setCancellationModal(false)} size='lg'>
              <Modal.Header closeButton>
                <Modal.Title>Refund & Cancellation Policy</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  <strong>Refund and Cancellation Policy for User Purchases from Merchants</strong>
                </p>
                <p>
                  <strong>1. Introduction</strong>
                </p>
                <p>
                  This Refund and Cancellation Policy ("Policy") governs the terms under which users
                  ("Users," "You") may request refunds or cancellations for purchases made from
                  merchants ("Merchants") on the Vasco Life LLC ("Vasco," "We," "Us") platform.
                  Vasco acts solely as a platform provider and is not a party to the transaction
                  between Users and Merchants. All refund and cancellation requests must be resolved
                  directly between the User and the Merchant.
                </p>
                <p>
                  <strong>2. Merchant Responsibility</strong>
                </p>
                <p>
                  2.1. Merchants are responsible for defining their own refund and cancellation
                  policies and making them available to Users before a purchase is completed.
                </p>
                <p>
                  2.2. Users must review and agree to the Merchant’s refund and cancellation
                  policies before making a purchase.
                </p>
                <p>
                  2.3. Vasco is not liable for any disputes, losses, or refunds related to a
                  Merchant’s products or services. Any refunds or cancellations must be handled
                  directly by the Merchant.
                </p>
                <p>
                  <strong>3. User Responsibilities</strong>
                </p>
                <p>
                  3.1. By making a purchase through Vasco’s platform, Users acknowledge and agree
                  that all refund and cancellation terms are set by the Merchant.
                </p>
                <p>
                  3.2. Users must contact the Merchant directly in case of a refund or cancellation
                  request.
                </p>
                <p>
                  3.3. Users must provide all relevant purchase details to the Merchant to
                  facilitate the refund or cancellation process.
                </p>
                <p>
                  <strong>4. Vasco’s Role in Dispute Resolution</strong>
                </p>
                <p>
                  4.1. Vasco is responsible for initiating refunds and transaction reversals for
                  purchases made through Vasco's payment provider, subject to verification of the
                  Merchant's service fulfillment.
                </p>
                <p>
                  4.2. Vasco may assist in verifying whether the Merchant has fulfilled the promised
                  goods or services if a dispute arises.
                </p>
                <p>
                  4.3. If a User claims non-delivery or unsatisfactory service, Vasco may request
                  evidence from both parties to confirm whether the Merchant has met their
                  obligations.
                </p>
                <p>
                  4.4. Vasco reserves the right to take necessary actions, including suspending a
                  Merchant’s account, if repeated service failures or disputes arise. Merchants will
                  be responsible for bearing any chargeback costs resulting from Users' disputes
                  with their issuing banks.
                </p>
                <p>
                  <strong>5. Fraudulent Transactions</strong>
                </p>
                <p>
                  5.1. If Vasco detects a fraudulent transaction, it may temporarily hold funds and
                  request verification from both the User and Merchant before processing further
                  transactions.
                </p>
                <p>
                  5.2. Any suspected fraudulent activity should be reported to Vasco at{' '}
                  <a href='mailto:support@vasco.life'>
                    <strong>support@vasco.life</strong>
                  </a>
                  .
                </p>
                <p>
                  <strong>6. Final Provisions</strong>
                </p>
                <p>
                  6.1. Vasco reserves the right to modify this Policy at any time. Updates will be
                  communicated to Users and Merchants in advance.
                </p>
                <p>
                  6.2. For any inquiries related to this Policy, Users may contact Vasco at{' '}
                  <a href='mailto:support@vasco.life'>
                    <strong>support@vasco.life</strong>
                  </a>
                  .
                </p>
                <p>
                  By making a purchase through Vasco’s platform, Users acknowledge that Vasco is not
                  responsible for any refund or cancellation and agree to resolve any disputes
                  directly with the Merchant.
                </p>
                <p> </p>
              </Modal.Body>
            </Modal>
            <Modal centered id='paymentModal' show={modal} onHide={() => setModal(false)}>
              <button
                type='button'
                className='btn-close'
                aria-label='Close'
                onClick={() => setModal(false)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '10px',
                  zIndex: '1000',
                }}
              ></button>
              <Modal.Body className='rounded p-0 m-0 h-100 w-100'>
                <iframe
                  ref={iframeRef}
                  allow='payment'
                  src={`${UI_URL}/payment-embed.html?paymentId=${
                    genericPaymentLinkID || paymentId
                  }`}
                  width='100%'
                  title='Payment Dialog'
                  height='600px'
                  onLoad={(e) => {
                    if (genericPaymentLinkID || paymentId) {
                      iframeRef.current?.contentWindow?.postMessage(
                        'iframeLoaded',
                        `${API}/Item/GetPaymentLink/${genericPaymentLinkID || paymentId}`
                      )
                    }
                  }}
                />
              </Modal.Body>
            </Modal>
            <Modal
              centered
              id='getPaymentModal'
              show={getPaymentModal}
              backdrop='static'
              onHide={() => {
                setGetPaymentUrl('')
                setGetPaymentModal(false)
              }}
            >
              <Modal.Body className='rounded p-0 m-0 h-100 w-100'>
                <iframe
                  allow='payment'
                  src={getPaymentUrl}
                  width='100%'
                  title='Payment Dialog'
                  height='600px'
                />
              </Modal.Body>
            </Modal>

            <div className='d-flex flex-column flex-root background-gradient' id='kt_app_root'>
              <div className='flex-column flex-column-fluid' id='kt_app_page'>
                <div className='flex-column-fluid'>
                  <div className='d-flex flex-column gap-10'>
                    <div
                      className='container-fluid pt-8'
                      id='kt_app_header_container'
                      style={{
                        zIndex: 1000,
                      }}
                    >
                      <div className='app-header-logo d-flex align-items-center ps-lg-2 me-lg-10'>
                        <a href='/sign-in'>
                          <img alt='Logo' src={Logo} className='h-25px' />
                        </a>
                      </div>

                      <div className='container'>
                        <div className='d-flex flex-column flex-root mt-10 d-flex gap-10 mb-6'>
                          <div className='w-100'>
                            <div className='card p-3 p-md-6'>
                              <h1 className='mb-5 fs-3 fs-lg-2x text-black'>
                                Subscription Payment Summary
                              </h1>

                              {isLoading ? (
                                <div className='mt-5'>
                                  <span data-kt-translate='general-progress'>Please wait...</span>
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </div>
                              ) : !data ? (
                                <div className='mt-10'>
                                  <p className='fw-semibold fs-6 text-danger'>
                                    {/* payment link not found */}
                                    Sorry, the payment link is not found or expired. Please contact
                                    the merchant.
                                  </p>
                                </div>
                              ) : (
                                <>
                                  <h3 className='mb-3 fs-3 fs-lg-2 text-black'>Customer Details</h3>
                                  {prop.values.linkType === 2 && (
                                    <p className='text-muted mb-5'>
                                      Please complete your contact information below and click
                                      'Confirm & Pay' to proceed with your purchase.
                                    </p>
                                  )}
                                  <div
                                    style={{
                                      border: '1px solid #eee',
                                      borderRadius: '8px',
                                      padding: '15px',
                                      marginBottom: '20px',
                                    }}
                                  >
                                    <div className='row mb-3'>
                                      <div className='col-12'>
                                        <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                          <span
                                            className='text-muted mb-1 mb-md-0'
                                            style={{minWidth: '180px'}}
                                          >
                                            Transaction Ref. No
                                          </span>
                                          <span className='fw-semibold'>
                                            {memberPayment?.referenceNumber || '-'}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className='row mb-3'>
                                      <div className='col-12 col-md-6 mb-3 mb-md-0'>
                                        {prop.values?.linkType === 2 ? (
                                          <>
                                            <label className='required form-label'>
                                              {intl.formatMessage({
                                                id: 'MEMBER.DETAIL.OVERVIEW.FIRST_NAME',
                                              })}

                                              <span className='position-relative'>
                                                <OverlayTrigger
                                                  placement='top'
                                                  overlay={
                                                    <Tooltip>
                                                      Enter the first name of the recipient for the
                                                      payment link.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                                </OverlayTrigger>
                                              </span>
                                            </label>
                                            <Field
                                              type='text'
                                              name='firstName'
                                              maxLength={50}
                                              className='form-control mb-2'
                                              placeholder={intl.formatMessage({
                                                id: 'MEMBER.DETAIL.OVERVIEW.FIRST_NAME',
                                              })}
                                              value={prop.values.firstName}
                                              onChange={(e) =>
                                                prop.setFieldValue('firstName', e.target.value)
                                              }
                                            />
                                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'>
                                              {prop.errors.firstName && prop.touched.firstName && (
                                                <div className='fv-help-block'>
                                                  {prop.errors.firstName}
                                                </div>
                                              )}
                                            </div>
                                          </>
                                        ) : (
                                          <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                            <span
                                              className='text-muted mb-1 mb-md-0'
                                              style={{minWidth: '180px'}}
                                            >
                                              Name
                                            </span>
                                            <span className='fw-semibold'>
                                              {memberPayment?.firstName || '-'}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-12 col-md-6'>
                                        {prop.values.linkType === 2 ? (
                                          <>
                                            <label className='required form-label'>
                                              {intl.formatMessage({
                                                id: 'MEMBER.DETAIL.OVERVIEW.LAST_NAME',
                                              })}

                                              <span className='position-relative'>
                                                <OverlayTrigger
                                                  placement='top'
                                                  overlay={
                                                    <Tooltip>
                                                      Enter the last name of the recipient.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                                </OverlayTrigger>
                                              </span>
                                            </label>
                                            <Field
                                              type='text'
                                              name='lastName'
                                              maxLength={50}
                                              className='form-control mb-2'
                                              placeholder={intl.formatMessage({
                                                id: 'MEMBER.DETAIL.OVERVIEW.LAST_NAME',
                                              })}
                                              value={prop.values.lastName}
                                              onChange={(e) =>
                                                prop.setFieldValue('lastName', e.target.value)
                                              }
                                            />
                                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'>
                                              {prop.errors.lastName && prop.touched.lastName && (
                                                <div className='fv-help-block'>
                                                  {prop.errors.lastName}
                                                </div>
                                              )}
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                              <span
                                                className='text-muted mb-1 mb-md-0'
                                                style={{minWidth: '180px'}}
                                              >
                                                Surname
                                              </span>
                                              <span className='fw-semibold'>
                                                {memberPayment?.lastName || '-'}
                                              </span>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>

                                    <div className='row mb-3'>
                                      <div className='col-12 col-md-6 mb-3 mb-md-0'>
                                        {prop.values.linkType === 2 ? (
                                          <>
                                            <label className='required form-label'>
                                              {intl.formatMessage({
                                                id: 'AUTH.BECOME_MEMBER.EMAIL',
                                              })}

                                              <span className='position-relative'>
                                                <OverlayTrigger
                                                  placement='top'
                                                  overlay={
                                                    <Tooltip>
                                                      Enter the recipient’s email address if email
                                                      is selected as the delivery method.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                                </OverlayTrigger>
                                              </span>
                                            </label>
                                            <Field
                                              type='text'
                                              name='emailAddress'
                                              className='form-control mb-2'
                                              placeholder={intl.formatMessage({
                                                id: 'AUTH.BECOME_MEMBER.EMAIL',
                                              })}
                                              value={prop.values.emailAddress}
                                              onChange={(e) =>
                                                prop.setFieldValue('emailAddress', e.target.value)
                                              }
                                            />
                                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'>
                                              {prop.errors.emailAddress &&
                                                prop.touched.emailAddress && (
                                                  <div className='fv-help-block'>
                                                    {prop.errors.emailAddress}
                                                  </div>
                                                )}
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                              <span
                                                className='text-muted mb-1 mb-md-0'
                                                style={{minWidth: '180px'}}
                                              >
                                                E-Mail
                                              </span>
                                              <span className='fw-semibold'>
                                                {memberPayment?.customerEmail || '-'}
                                              </span>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                      <div className='col-12 col-md-6'>
                                        {prop.values?.linkType === 2 ? (
                                          <>
                                            <label className='required form-label'>
                                              {intl.formatMessage({id: 'AUTH.BECOME_MEMBER.PHONE'})}

                                              <span className='position-relative'>
                                                <OverlayTrigger
                                                  placement='top'
                                                  overlay={
                                                    <Tooltip>
                                                      Provide the recipient’s phone number to send
                                                      the payment link.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <i className='bi bi-info-circle text-primary ms-1'></i>
                                                </OverlayTrigger>
                                              </span>
                                            </label>

                                            <InputMask
                                              mask={'+\\9\\7\\1\\ 99 999 9999'}
                                              name='mobilePhoneNumber'
                                              className='form-control'
                                              type='phoneNumber'
                                              placeholder={intl.formatMessage({
                                                id: 'AUTH.BECOME_MEMBER.PHONE',
                                              })}
                                              value={prop.values.mobilePhoneNumber}
                                              onChange={(e) => {
                                                prop.setFieldValue(
                                                  'mobilePhoneNumber',
                                                  e.target.value
                                                )
                                              }}
                                            />

                                            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback'>
                                              {prop.errors.mobilePhoneNumber &&
                                                prop.touched.mobilePhoneNumber && (
                                                  <div className='fv-help-block'>
                                                    {prop.errors.mobilePhoneNumber}
                                                  </div>
                                                )}
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                              <span
                                                className='text-muted mb-1 mb-md-0'
                                                style={{minWidth: '180px'}}
                                              >
                                                Phone
                                              </span>
                                              <span className='fw-semibold'>
                                                {formatPhoneNumber(
                                                  memberPayment?.customerPhone || ''
                                                ) || '-'}
                                              </span>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <h3 className='mb-3 mt-4 mt-md-5 fs-3 fs-lg-2 text-black'>
                                    Payment Details
                                  </h3>
                                  <div
                                    style={{
                                      border: '1px solid #eee',
                                      borderRadius: '8px',
                                      padding: '15px',
                                      marginBottom: '20px',
                                    }}
                                  >
                                    <div className='row mb-3'>
                                      <div className='col-12'>
                                        <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                          <span
                                            className='text-muted mb-1 mb-md-0'
                                            style={{minWidth: '180px'}}
                                          >
                                            Business Name
                                          </span>
                                          <span className='fw-semibold'>
                                            {memberPayment?.merchantName || '-'}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className='row mb-3'>
                                      <div className='col-12 col-md-6 mb-3 mb-md-0'>
                                        <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                          <span
                                            className='text-muted mb-1 mb-md-0'
                                            style={{minWidth: '180px'}}
                                          >
                                            Subscription Plan
                                          </span>
                                          <span className='fw-semibold'>
                                            {memberPayment?.product || '-'}
                                          </span>
                                        </div>
                                      </div>
                                      <div className='col-12 col-md-6'>
                                        <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                          <span
                                            className='text-muted mb-1 mb-md-0'
                                            style={{minWidth: '180px'}}
                                          >
                                            Plan Duration
                                          </span>
                                          <span className='fw-semibold'>
                                            {memberPayment?.planDuration} Month(s)
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className='row mb-3'>
                                      <div className='col-12 col-md-6 mb-3 mb-md-0'>
                                        <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                          <span
                                            className='text-muted mb-1 mb-md-0'
                                            style={{minWidth: '180px'}}
                                          >
                                            Subscription Start Date
                                          </span>
                                          <span className='fw-semibold'>
                                            {memberPayment?.startDate &&
                                              moment().utc().format('DD/MM/YYYY')}
                                          </span>
                                        </div>
                                      </div>
                                      <div className='col-12 col-md-6'>
                                        <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                          <span
                                            className='text-muted mb-1 mb-md-0'
                                            style={{minWidth: '180px'}}
                                          >
                                            Subscription End Date
                                          </span>
                                          <span className='fw-semibold'>
                                            {memberPayment?.endDate &&
                                              moment()
                                                .add(memberPayment?.planDuration, 'months')
                                                .utc()
                                                .format('DD/MM/YYYY')}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className='row'>
                                      <div className='col-12 col-md-6 mb-3 mb-md-0'>
                                        <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                          <span
                                            className='text-muted mb-1 mb-md-0'
                                            style={{minWidth: '180px'}}
                                          >
                                            Amount to be Charged
                                          </span>
                                          <span className='fw-semibold'>
                                            AED {memberPayment?.amount?.toFixed(2) || '-'}
                                          </span>
                                        </div>
                                      </div>
                                      <div className='col-12 col-md-6'>
                                        <div className='d-flex flex-column flex-md-row align-items-md-center'>
                                          <span
                                            className='text-muted mb-1 mb-md-0'
                                            style={{minWidth: '180px'}}
                                          >
                                            Payment Frequency
                                          </span>
                                          <span className='fw-semibold'>
                                            {memberPayment?.paymentFrequency === 1
                                              ? 'Recurring Monthly'
                                              : 'Annual'}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className='row mb-4'>
                                    <div className='col-12 d-flex flex-column align-items-center gap-2'>
                                      <a
                                        className='text-primary cursor-pointer w-100 text-center text-md-start'
                                        onClick={() => setTermsModal(true)}
                                        style={{cursor: 'pointer'}}
                                      >
                                        Terms & Conditions Agreement
                                      </a>

                                      {memberPayment?.termsAndConditionsEnabled &&
                                        memberPayment?.termsAndConditions && (
                                          <a
                                            className='text-primary cursor-pointer w-100 text-center text-md-start'
                                            onClick={() => setTermsModalMerchant(true)}
                                            style={{cursor: 'pointer'}}
                                          >
                                            {memberPayment?.termsAndConditionsTitle}
                                          </a>
                                        )}

                                      <a
                                        className='text-primary cursor-pointer w-100 text-center text-md-start'
                                        onClick={() => setCancellationModal(true)}
                                        style={{cursor: 'pointer'}}
                                      >
                                        Refund & Cancellation Policy
                                      </a>
                                    </div>
                                  </div>

                                  <div className='row mb-4'>
                                    <div className='col-12'>
                                      <div className='d-flex flex-column flex-md-row gap-3 justify-content-center'>
                                        <button
                                          type='submit'
                                          className='btn btn-success px-5 py-3 w-100 w-md-auto'
                                          onClick={() => {
                                            if (
                                              !isTermsAccepted &&
                                              memberPayment?.termsAndConditionsEnabled &&
                                              memberPayment?.termsAndConditions
                                            ) {
                                              toast.error(
                                                'Please accept the terms and conditions before proceeding.',
                                                {
                                                  position: 'top-right',
                                                  autoClose: 5000,
                                                  hideProgressBar: false,
                                                  closeOnClick: true,
                                                  pauseOnHover: true,
                                                  draggable: false,
                                                  progress: undefined,
                                                  theme: 'light',
                                                }
                                              )
                                              return
                                            }
                                            prop.submitForm()
                                          }}
                                        >
                                          Confirm & Pay
                                        </button>
                                        <button
                                          type='button'
                                          onClick={() => setCancelled(true)}
                                          className='btn btn-danger px-5 py-3 w-100 w-md-auto'
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div className='row mb-4'>
                                    <div className='col-12'>
                                      <div
                                        style={{
                                          backgroundColor: '#eeeeee',
                                          padding: '15px',
                                          borderRadius: '8px',
                                        }}
                                      >
                                        <h4 className='fs-6 mb-3'>
                                          Important Notes Before Payment
                                        </h4>
                                        <ul className='list-unstyled mb-0 px-2'>
                                          <li className='mb-2 text-break'>
                                            • Your payment link is valid until{' '}
                                            {moment
                                              .utc(memberPayment?.expireDate)
                                              .format('DD/MM/YYYY HH:mm')}
                                            . Make sure to complete your payment before it expires.
                                          </li>
                                          <li className='mb-2 text-break'>
                                            • Your transaction is securely processed via MyFatoorah
                                            services. For your safety, don't share this link with
                                            anyone.
                                          </li>
                                          <li className='mb-2 text-break'>
                                            • You can pay using [Visa, Mastercard, Apple Pay,
                                            PayPal, etc.]. Some payment methods may require
                                            additional verification.
                                          </li>
                                          <li className='mb-2 text-break'>
                                            • If you need to cancel or modify your payment, please
                                            reach out to help@vasco.life before proceeding.
                                          </li>
                                          <li className='mb-2 text-break'>
                                            • If this is a subscription payment, it may renew
                                            automatically. You can manage or cancel it before the
                                            next billing cycle.
                                          </li>
                                          <li className='text-break'>
                                            • Once your payment is successful, you'll receive a
                                            confirmation email with your receipt. If you don't see
                                            it, check your spam folder or contact support.
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      }}
    </Formik>
  )
}
